<div class="app-wrapper">
  <!-- <router-outlet (deactivate)="onDeactivate()"></router-outlet> -->
  <router-outlet (activate)="onActivate()"></router-outlet>
</div>
